import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PosterItems from './PosterItems';
import { EVENT_ID, POSTER_API_URL } from '../constants';
import axios from 'axios';

const styles = (theme) => ({
  posterDiv: {
    padding: '20px 50px',
    backgroundColor: '#f4f4f4',
    height: 'calc(100% - 85px)',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: '15px 35px',
      height: 'calc(100% - 94.67px)',
      overflowY: 'auto',
    },
  },
  searchBar: {
    backgroundColor: '#fff',
    border: 'solid 1px #c9c9c9',
    borderRadius: '5px',
    '&:focus': {
      border: 'solid 1px #377ac6',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  pageDiv: {
    paddingBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  loadMoreDiv: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      borderTop: '1px solid #e0e0e0',
      margin: '0 25px',
      padding: '10px 0',
    },
  },
  mobileTab: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
  },
  tabBox: {
    height: '650px',
    overflowY: 'auto',
  },
});

class Poster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchkeyword: '',
      postItem: [],
      pageSize: null,
      isMobile: window.matchMedia('(max-width:960px)').matches,
      loadMore: true,
      nowPage: 1,
      postCnt: null,
      delay: null,
    };
    this.getPosterData = this.getPosterData.bind(this);
  }

  componentDidMount() {
    this.getPosterData();
  }

  getPosterData(_txt) {
    let limit = -1;
    console.log('키워드 :' + this.props.keyword);
    let search = this.props.keyword.length > 0 ? '&nameTitle=' + this.props.keyword : '';

    axios.get(`${POSTER_API_URL}/poster/list?tts=${new Date().getTime()}&eventId=${EVENT_ID}&limit=${limit}${search}`).then((res) => {
      let data = res.data.Items;

      this.setState({ postItem: data });
    });
  }

  scrollTop = () => {
    // eslint-disable-next-line
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const el = document.getElementById('posterBox');
    el.scrollTop = scrollTop;
  };

  render() {
    const { classes } = this.props;

    const filteredList = (datas) => {
      if (datas.length > 0) {
        return datas.map((item, idx) => {
          return (
            <PosterItems
              key={idx}
              data={item}
              order={item.order}
              country={item.country}
              regNo={item.regNo}
              email={item.email}
              dept={item.dept}
              presenter={item.presenter}
              position={item.position}
              profession={item.profession}
              ptTitle={item.ptTitle}
              firstName={item.firstName}
              lastName={item.lastName}
              keyword1={item.keyword1}
              keyword2={item.keyword2}
              keyword3={item.keyword3}
            />
          );
        });
      }
    };

    return (
      <React.Fragment>
        <div style={{ backgroundColor: '#fff', marginBottom: '20px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '20px', padding: 16, marginLeft: 10 }}>Search Result</div>
          <Typography component="div">
            {this.state.isMobile ? (
              <Box p={3} style={{ minHeight: '350px' }}>
                {filteredList(this.state.postItem)}
              </Box>
            ) : (
              <Box p={3} className={classes.tabBox} id={'posterBox'}>
                {filteredList(this.state.postItem)}
              </Box>
            )}
          </Typography>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Poster);
